<template>
    <div class="authority_box">
        <div class="authority_bac"></div>
        <div class="open_box">
            <div class="open_top">
                <div style="display: flex">
                    <img
                        class="authority_logo"
                        src="@/assets/img/mobile-img/extend-logo.png"
                        alt=""
                    />
                    <div>
                        <h4>开通合伙人收款商户Ⅰ</h4>
                        <p>设置佣金商户</p>
                    </div>
                </div>
                <img
                    v-if="isSign"
                    class="is_open"
                    src="@/assets/img/mobile-img/is-open.png"
                    alt=""
                />
                <div v-else class="open_btn_box">
                    <Button class="open_btn" @click="$router.replace('/partner-service')">
                        去开通
                    </Button>
                </div>
            </div>
            <div class="open_text">
                <van-checkbox v-model="readAgreement">
                    我已阅读并同意
                    <router-link to="/extend/agreement-extend"
                        >《中文知识网分享推广用户协议》</router-link
                    >
                    <template #icon="props">
                        <img
                            class="open_radio_icon"
                            :src="
                                props.checked
                                    ? require('@/assets/img/mobile-img/radioS.png')
                                    : require('@/assets/img/mobile-img/radio.png')
                            "
                        />
                    </template>
                </van-checkbox>
            </div>
            <div class="open_bottom">
                <Button class="open_btn" :disabled="!(isSign && readAgreement)" @click="toApply">
                    确认开通权限
                </Button>
            </div>
        </div>
        <div class="authority_bottom">
            <h1 class="authority_bottom_title">简单四步赚佣金</h1>
            <img class="authority_bottom_img" src="@/assets/img/mobile-img/procedure.png" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isSign: false,
            readAgreement: false,
        };
    },
    created() {
        this.getSignStatus();
    },
    methods: {
        async getSignStatus() {
            let res = await this.$apis.extendServe.signStatus();
            if (res.resultCode === "200") this.isSign = res.data;
        },
        async toApply() {
            let res = await this.$apis.extendServe.OpenExtendPermission();
            if (res.resultCode === "200") {
                this.$router.replace("/extend/open-extend");
            }
        },
    },
};
</script>

<style scoped lang="scss">
.authority_box {
    padding: 0 12px 20px;
    overflow: hidden;
    .authority_bac {
        position: absolute;
        left: 0;
        background: url(~@/assets/img/mobile-img/extend-bg.png);
        background-size: 100% 100%;
        width: 100vw;
        height: 192px;
    }
    .open_box {
        position: relative;
        z-index: 1;
        margin-top: 100px;
        padding: 15px;
        height: 198px;
        background: #ffffff;
        border-radius: 8px;
        .open_top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 72px;
            padding-bottom: 19px;
            border-bottom: 1px solid #eeeeee;
            .authority_logo {
                margin-right: 13px;
                width: 45px;
                height: 45px;
            }
            .is_open {
                width: 55px;
                height: 49px;
            }
            h4 {
                font-size: 15px;
                color: #333333;
                line-height: 21px;
                margin-bottom: 8px;
            }
            p {
                font-size: 13px;
                color: #999999;
                line-height: 19px;
            }
            .open_btn_box {
                width: 68px;
                height: 30px;
            }
        }
        .open_text {
            margin-top: 21px;
            font-size: 12px;
            color: #666666;
            line-height: 17px;
            &::v-deep .van-checkbox__icon {
                line-height: 17px;
            }
            .open_radio_icon {
                width: 12px;
                height: 12px;
            }
        }
        .open_bottom {
            margin-top: 15px;
            height: 44px;
        }
        .open_btn {
            width: 100%;
            height: 100%;
            background: #4a79f1;
            border-radius: 22px;
            font-size: 13px;
            color: #ffffff;
            &[disabled] {
                opacity: 0.4;
            }
        }
    }
    .authority_bottom {
        margin-top: 12px;
        padding: 14px;
        height: 313px;
        background: #ffffff;
        border-radius: 8px;
        .authority_bottom_title {
            margin-bottom: 20px;
            font-size: 17px;
            color: #333333;
            line-height: 24px;
        }
        .authority_bottom_img {
            width: 192px;
            height: 239px;
        }
    }
}
</style>
